import { render, staticRenderFns } from "./BCXMessengerHeader.vue?vue&type=template&id=a025e776&scoped=true"
import script from "./BCXMessengerHeader.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerHeader.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerHeader.vue?vue&type=style&index=0&id=a025e776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a025e776",
  null
  
)

export default component.exports